module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1",
    attrs: {
      "id": "June1"
    }
  }, [_vm._v("Saturday, June 1")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("Lake Michigan, Upbound")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We unloaded yesterday morning at Gary, and then loaded coal last night at the KCBX terminal along the Calumet River south of Chicago. The train carrying our coal arrived late, so we didn’t clear the dock until after 2:00 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")]), _vm._v(" At about 3:00 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")]), _vm._v(" tomorrow, we should be at the power plant on Lake Charlevoix at Advance, Michigan, inland from Charlevoix. We’ve encountered some fog, though, and we’re "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("supposed to get some heavy rain for the next twenty-four hours. That could force us to anchor somewhere en route. To reach Lake Charlevoix from “the big lake” you must go through a channel that’s slightly wider than the boat. The captain probably won’t attempt that unless weather conditions are good. We’ve got one guy leaving at Advance, and three others scheduled to go on vacation when we reach the sand dock at Brevort the following day, so they’re all concerned about the possibility of a delay. As we say on the boats, they’ve got a dose of “channel fever.” Now that they’re close to getting off, that’s all they can think about. They often have trouble sleeping and they become real cranky if the boat suffers any delays.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("One of those leaving is Gene Schaedig, our second cook. Ron Bredow, now the porter, will take over as second cook and Jimmy Atkins, a deckhand, will come into the galley as porter. Neither Ron nor Jimmy are very experienced, so I’ll have to keep an eye on them to make sure their jobs are done properly. That’s something I haven’t had to worry about when Gene was here.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fog is depressing. There are times when I feel trapped on the boat. When you add the loud blare of the fog whistle every couple of minutes, it’s enough to drive you loony.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The lake and shoreline were so beautiful when we were downbound. Now all we can see are the boat and a gray void beyond. I can’t even imagine what it must have been like on boats in the days before radar and other sophisticated navigational aids. One minute they were feeling their way along in a fog, the next they had run aground or collided with another ship. That makes our present situation seem pretty trivial.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d35dc3d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/June1.vue
// module id = 99
// module chunks = 0